import React, { useContext, useEffect, useState } from "react";
import "./Home.css";
import UserNav from "../../Components/UserNav.jsx/UserNav";
import AlertContext from "../../utils/alertContext";
import MenuFilter from "../../Components/MenuFilter/MenuFilter";
import BizRow from "../../Components/BizRow/BizRow";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";


// const response = [
//   {
//     _id: '0dha8abadhduabbu',
//     username: "pedicure",
//     title: "Pedicure",
//     category: 'nail',
//     description: 'Duration: 45m',
//     img: 'https://static.wixstatic.com/media/e9c9d7_be017784f9f24a2ca31d8a59269142b6~mv2.jpg/v1/fill/w_406,h_251,al_c,lg_1,q_80/e9c9d7_be017784f9f24a2ca31d8a59269142b6~mv2.webp',
//     rating: '$27'
//   },
//   {
//     _id: '1df4fg44ggadhduabbu',
//     username: "manicure",
//     title: "Manicure",
//     category: 'nail',
//     description: 'Duration: 30m',
//     img: 'https://static.wixstatic.com/media/e9c9d7_48bd2466c04a4fd7a4fdd17e78ab13f4~mv2.jpg/v1/fill/w_630,h_390,al_c,lg_1,q_80/e9c9d7_48bd2466c04a4fd7a4fdd17e78ab13f4~mv2.webp',
//     rating: '$47'
//   },
//   {
//     _id: '2ff4fg44ggadhduabbu',
//     username: "eyebrowwax",
//     title: "Eyebrows Wax",
//     category: 'waxing',
//     description: 'Duration: 15m',
//     img: 'https://static.wixstatic.com/media/e9c9d7_c1e3101f4884431c9cb0090fd0fa0f0e~mv2.jpg/v1/fill/w_980,h_606,al_c,q_85,usm_0.66_1.00_0.01/e9c9d7_c1e3101f4884431c9cb0090fd0fa0f0e~mv2.webp',
//     rating: '$10'
//   },
// ]

const Menu = (props) => {
  const alert = useContext(AlertContext);
  const [userName, setUserName] = useState();
  const [loading, setLoading] = useState(true);
  const [userPhone, setUserPhone] = useState();
  const [bizItems, setBizItems] = useState([]);
  const [bizCategories, setBizCategories] = useState([]);
  const [currentBizCategories, setCurrentBizCategories] = useState([]);
  const location = useLocation()
  const navigate = useNavigate()
  // TODO: use less hooks //
  useEffect(() => {
    const initializeMenu = async () => {
      try {
        const response = await axios.get("/services");
        setBizItems(response.data);
        const categoriesSet = [
          ...new Set(
            response.data.map((bizItem) => bizItem.category.toUpperCase())
          ),
        ];
        setBizCategories(categoriesSet);
        setCurrentBizCategories(categoriesSet);
        setLoading(false)
      } catch (err) {
        console.log(err);
        alert.setAlert({
          message: "Menu could not load right now, check back soon!",
          type: "danger",
        });
        setLoading(false)
      }
    };
    if (location.state === null) {
      navigate('/')
    } else {
      const up = location.state.phone;
      const un = location.state.name;
    setUserName(un)
    setUserPhone(up)
    initializeMenu();
    }
    // eslint-disable-next-line
  }, []);

  const filterBizByCategory = (category) => {
    if (category === "ALL") {
      setCurrentBizCategories(bizCategories);
    } else {
      setCurrentBizCategories([category]);
    }
  };

  const setChild = (loading) => {
    setLoading(loading)
}
  
if (loading) return null;

  return (
    <>
    <UserNav/>
    <MenuFilter
        menuCategories={bizCategories}
        handleClick={filterBizByCategory}
      />
      <p className="center-align">{alert.message}</p>
      <section className="menu-wrapper">
        {currentBizCategories.map((bizCategory) => {
          return (
            <div className="menu-category-wrapper" key={bizCategory}>
              <span className="menu-category">{bizCategory+"S"}</span>
              {bizItems.map((bizInfo) =>
                bizCategory === bizInfo.category.toUpperCase() ? (
                  <BizRow {...bizInfo} key={bizInfo.username} userName={userName} userPhone={userPhone} setChild={(e)=> setChild(e)} />
                ) : null
              )}
            </div>
          );
        })}
      </section>
    </>
  );
};

export default Menu;
